import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/** Capture each `.design-cat-page` inside root into a multi-page A4 PDF. */
export async function exportDesignCataloguePdf(
  root: HTMLElement,
  filename: string,
): Promise<void> {
  const pages = Array.from(root.querySelectorAll<HTMLElement>('.design-cat-page'));
  if (pages.length === 0) throw new Error('Nothing to export — add a cover or products first.');

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < pages.length; i += 1) {
    const page = pages[i]!;
    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
    });
    const img = canvas.toDataURL('image/jpeg', 0.92);
    if (i > 0) pdf.addPage();
    pdf.addImage(img, 'JPEG', 0, 0, pageWidth, pageHeight);
  }

  const safe = filename.replace(/[^\w.\-]+/g, '_').replace(/_+/g, '_') || 'catalogue';
  pdf.save(safe.endsWith('.pdf') ? safe : `${safe}.pdf`);
}
